import { useTranslation } from 'react-i18next';
import React, { ReactNode } from 'react';

import { IconActionDeposit, IconActionDepositDark } from '@/assets/stream';
import { Modal, Loading, ProjectAvatar } from '@/components';
import { useSwitch, useTheme } from '@/hooks';
import { DisplayedProject } from '@/views/Portfolio/utils/project';
import { CHAINS_DICT } from '@/utils';

import { LinkParsedContentMono } from '../../Content';
import { useUserPortfolioList } from '../hook';
import { ActionWrapper, ActionProps } from './Wrapper';
import style from './index.module.scss';

export const ProtocolDepositor = (props: ActionProps) => {
  const { t } = useTranslation();

  const { data: action } = props;
  const { isDark } = useTheme();
  const icon = isDark ? IconActionDepositDark : IconActionDeposit;

  const { on, turnOn, turnOff } = useSwitch();

  return (
    <>
      <ActionWrapper
        {...props}
        onActionClick={turnOn}
        avatar={<img src={icon} className={style.actionIcon} alt="action" />}>
        {t('Actions_ProtocolDepositor.6krhc2', { label: `[${action.data.protocol_name}]` })}
      </ActionWrapper>
      {on ? <ConfirmModal action={action} turnOff={turnOff} icon={icon} /> : null}
    </>
  );
};

const { CommonModal } = Modal;

const ConfirmModal = ({
  action,
  turnOff,
  icon,
}: {
  turnOff: () => void;
  action: ActionProps['data'];
  icon: ReactNode;
}) => {
  const { t } = useTranslation();

  const { data, isLoading } = useUserPortfolioList(action.data.protocol_id!);

  const hasDeposited = !!data?.portfolio_list?.length;
  const project = hasDeposited ? new DisplayedProject(data!.project, data!.portfolio_list) : null;

  return (
    <CommonModal turnOff={turnOff} containerClassName={style.confirmModal}>
      <div className={style.cmTitle}>
        <img src={IconActionDeposit} className={style.actionIcon} alt="action" />
        {t('Actions_ProtocolDepositor.1c2ziy9')}
      </div>
      <div className={style.cmField}>
        <div className={style.cmfTitle}>{t('Actions_ProtocolDepositor.1jqodyw')}</div>
        <div className={style.protocolName}>
          <img
            src={CHAINS_DICT[action.data.chain_id!].logo}
            className={style.actionIcon}
            alt="action"
          />
          {action.data.protocol_name}
        </div>
      </div>
      <div className={hasDeposited ? style.cmField : style.cmFieldRow}>
        <div className={style.cmfTitle}>{t('Actions_ProtocolDepositor.jm03h9')}</div>
        {isLoading ? (
          <Loading />
        ) : hasDeposited ? (
          <div className={style.protocolName}>
            <ProjectAvatar chain={project?.chain} url={project?.logo} size={24} />
            <span className={style.projectName}>{project?.name}</span>
            {project?._netWorth}
          </div>
        ) : (
          <span className={style.cmfValue}>--</span>
        )}
      </div>
      <div className={style.cmField}>
        <div className={style.cmfTitle}>{t('Actions_ProtocolDepositor.1y3d9ek')}</div>
        <div className={style.cmfBgValue}>
          <LinkParsedContentMono content={action.data.desc} linkClassnames={style.cmLink} />
        </div>
      </div>
      <div className={style.cmField}>
        <div className={style.cmfTitle}>{t('Actions_ProtocolDepositor.4ay8rz')}</div>
        <LinkParsedContentMono content={action.data.related_link} linkClassnames={style.cmLink} />
      </div>
    </CommonModal>
  );
};
